import Vue from "vue";
import Router from "vue-router";
import { EasyAuth } from "@unimed/unijs/easy";
import Navigation from "@/views/Navigation.vue";
import store from "./store/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL
});

const mainRoute = [
  {
    path: "/",
    redirect: "/adm"
  }
];
const controlRoutes = [
  {
    path: "//*",
    redirect: to => to.path.replace("//", "/")
  },
  {
    name: "navigation",
    path: "/*",
    component: Navigation
  }
];

router.addRoutes(mainRoute);

Vue.use(EasyAuth, { store, router });

router.addRoutes(controlRoutes);

router.beforeEach((to, from, next) => {
  if (from.path.match("login") && !to.path.match("login")) {
    global.location.href = to.path;
  } else {
    next();
  }
});

export default router;
